let tenantId = 888001;

export function setTenantId(val) {
    tenantId = val;
}

export function getTenantId() {
    return tenantId;
}
